module.exports = __webpack_public_path__ + "img/11_121.f5817752.png";